import React from 'react';
import { Card, Badge } from '@/components/ui';
import { useNavigate } from 'react-router-dom';
import { Package, Truck, Users, HardHat, Receipt, Layers, ArrowRight } from 'lucide-react';
import { cn } from '@/utils/cn';

export function RequestsModulesGrid() {
  const navigate = useNavigate();

  const MODULES = [
    {
      id: 'materials',
      title: 'Yêu cầu Vật tư',
      description: 'Lập phiếu yêu cầu vật tư, cây xanh, phân bón từ kho hoặc đề xuất mua mới.',
      icon: <Package className="w-6 h-6" />,
      color: 'emerald',
      path: '/requests/list',
      stats: '15 Yêu cầu',
      gradient: 'from-emerald-400 to-teal-500',
      bgLight: 'bg-emerald-50',
      textDark: 'text-emerald-700'
    },
    {
      id: 'equipment',
      title: 'Yêu cầu Cơ giới',
      description: 'Điều động máy xúc, cần cẩu, xe tải và các thiết bị chuyên dụng thi công.',
      icon: <Truck className="w-6 h-6" />,
      color: 'blue',
      path: '/equipment/requests',
      stats: '4 Đang chờ',
      gradient: 'from-blue-500 to-cyan-500',
      bgLight: 'bg-blue-50',
      textDark: 'text-blue-700'
    },
    {
      id: 'manpower',
      title: 'Yêu cầu Nhân lực',
      description: 'Xin tăng ca, bổ sung nhân công thời vụ hoặc kỹ sư chuyên môn cho dự án.',
      icon: <Users className="w-6 h-6" />,
      color: 'purple',
      path: '/requests/manpower',
      stats: '1 Đề xuất',
      gradient: 'from-purple-500 to-pink-500',
      bgLight: 'bg-purple-50',
      textDark: 'text-purple-700'
    },
    {
      id: 'subcontractor',
      title: 'Yêu cầu Thầu phụ',
      description: 'Đề xuất giao khoán, thuê ngoài dịch vụ thi công hoặc chuyên gia tư vấn.',
      icon: <HardHat className="w-6 h-6" />,
      color: 'amber',
      path: '/requests/subcontractor',
      stats: 'Phê duyệt',
      gradient: 'from-amber-400 to-orange-500',
      bgLight: 'bg-amber-50',
      textDark: 'text-amber-700'
    },
    {
      id: 'payment',
      title: 'Đề nghị Thanh toán',
      description: 'Lập hồ sơ tạm ứng, thanh toán khối lượng hoàn thành cho nhà thầu hoặc NCC.',
      icon: <Receipt className="w-6 h-6" />,
      color: 'indigo',
      path: '/construction/payments',
      stats: '2 Hồ sơ',
      gradient: 'from-indigo-500 to-violet-500',
      bgLight: 'bg-indigo-50',
      textDark: 'text-indigo-700'
    },
    {
      id: 'others',
      title: 'Yêu cầu Khác',
      description: 'Các đề xuất, tờ trình chung hoặc các form nghiệp vụ tùy chỉnh khác.',
      icon: <Layers className="w-6 h-6" />,
      color: 'slate',
      path: '/requests/others',
      stats: 'Tùy chỉnh',
      gradient: 'from-slate-500 to-gray-600',
      bgLight: 'bg-slate-100',
      textDark: 'text-slate-700'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 h-full">
      {MODULES.map((mod) => (
        <Card
          key={mod.id}
          onClick={() => navigate(mod.path)}
          className="group relative overflow-hidden bg-white border-2 border-slate-100 hover:border-blue-200 shadow-sm hover:shadow-xl rounded-3xl p-6 cursor-pointer transition-all duration-300 hover:-translate-y-1 h-full flex flex-col"
        >
          <div className={cn("absolute top-0 right-0 w-32 h-32 bg-gradient-to-br opacity-5 rounded-bl-full transition-transform duration-500 group-hover:scale-110", mod.gradient)} />

          <div className="flex items-start justify-between mb-4">
            <div className={cn("w-14 h-14 rounded-2xl flex items-center justify-center shadow-inner transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3", mod.bgLight, mod.textDark)}>
              {mod.icon}
            </div>
            <Badge variant="custom" className={cn("bg-slate-50 text-slate-600 border border-slate-100 font-bold px-2.5 py-1 text-[10px]")}>
              {mod.stats}
            </Badge>
          </div>

          <h4 className="text-lg font-black text-slate-800 mb-2 group-hover:text-blue-700 transition-colors">{mod.title}</h4>
          <p className="text-xs text-slate-500 leading-relaxed mb-6 line-clamp-2 min-h-[36px] flex-grow">
            {mod.description}
          </p>

          <div className="flex items-center text-sm font-bold text-blue-600 opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300 mt-auto">
            Truy cập ngay <ArrowRight className="w-4 h-4 ml-1.5" />
          </div>
        </Card>
      ))}
    </div>
  );
}
